import detail from './detail';

class Template {
    name = 'template';
    constructor() {
        this.detail = detail;
    }
}
export default new Template();
